import { render } from "./ShowMore.component.vue?vue&type=template&id=0480daf5&scoped=true"
import script from "./ShowMore.component.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowMore.component.vue?vue&type=script&setup=true&lang=js"

import "./ShowMore.component.vue?vue&type=style&index=0&id=0480daf5&lang=scss&scoped=true"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0480daf5"],['__file',"src/components/sharedComponents/ShowMore.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0480daf5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0480daf5', __exports__)) {
    console.log('reload')
    api.reload('0480daf5', __exports__)
  }
  
  module.hot.accept("./ShowMore.component.vue?vue&type=template&id=0480daf5&scoped=true", () => {
    console.log('re-render')
    api.rerender('0480daf5', render)
  })

}


export default __exports__